<div class="u-text-center">
  <h1 style="text-align: center;">Ein Fehler ist aufgetreten:</h1>
  <div style="text-align: center;">
    <p>Fehlermeldung: {{data.message}}</p>
    <button nxButton="primary small" class="my-search-button" type="button" (click)="toggleTechnicalError()">
      Expandieren
    </button>
    <button nxButton="primary small" (click)="generateSendReport()"  type="button" class="my-search-button">Fehlerbericht senden</button>
    <!-- <button *ngIf="showRelogin()" nxButton="primary small" class="my-search-button" type="button" (click)="relogin()">
      Anmeldung
    </button> -->
    <button *ngIf="showRelogin()" nxButton="primary small" class="my-search-button" type="button" (click)="reloginInTab()">
      Anmeldung in neuem Tab
    </button>
    
  </div>
</div>

<div *ngIf="showTechnicalError">    
  <p>Fehlercode: {{data.errorCode}}</p>
  <p *ngIf="data.debugId">KorrelationId: {{data.debugId}}</p>
  <!-- <div style="max-height: 300px; overflow-y: auto;">
    <p>{{getTrackerDetails()}}</p>
  </div>
  <div nxCol="2">
    <button nxButton="primary small" (click)="generateSendReport()"  type="button" class="my-search-button" >E-Mail-Fehler</button>
  </div> -->
</div>
